import actions from '.'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

const sendMessage = (dispatch, getState, message, path) => {
  const gamerId = getState().auth.uid
  const currentGamer = getState().currentGamer
  const redirectPath = gamerId ? 'gauntlet' : ''

  firebaseService.add(
    path,
    {
      email: currentGamer.email,
      gamerId: gamerId,
      message,
      username: currentGamer.username,
    },
    N.GAMERS,
  )
  dispatch(actions.clearUserInterface())
  dispatch(actions.routeTo(redirectPath))
  dispatch(actions.alertGamer({ message: 'Message Sent!', }))
}

export default {
  sendFeatureRequest: () => {
    return (dispatch, getState) => {
      const message = getState().userInterface.featureRequest
      sendMessage(dispatch, getState, message, 'featureRequests/')
    }
  },
  sendSupportMessage: () => {
    return (dispatch, getState) => {
      const message = getState().userInterface.supportMessage
      sendMessage(dispatch, getState, message, 'supportMessages/')
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/support.js